import { FC, useEffect, useState } from 'react'
import { useParams } from 'react-router'
import { Container, ContainerTitle } from '../components/Container'
import { Detail, List } from '../components/Premium'
import { ITokenOriginalView } from '../types/lot'
import { auth as authAPI } from '../utils/api/index'

export const PremiumPage: FC = () => {
    const [token, setToken] = useState<ITokenOriginalView>()
    const [premiums, setPremiums] = useState<ITokenOriginalView[]>([])

    const { id } = useParams<{ id: string }>()

    useEffect(() => {
        async function getData() {
            const res = await authAPI.premium.id(id).then((res) => {
                setToken(res.data)
                return res
            })
            authAPI.premium.list({ userId: res.data.userId }).then((res) => {
                const filtered = res.data.rows.filter((r) => r.id !== id)
                setPremiums(filtered)
            })
        }
        getData()
    }, [id])

    return (
        <>
            {token && (
                <Container>
                    <Detail token={token}></Detail>
                    {!!premiums.length && (
                        <>
                            <ContainerTitle title="Featured Premium"></ContainerTitle>
                            <List tokens={premiums}></List>
                        </>
                    )}
                </Container>
            )}
        </>
    )
}
